export type MusicScene = 'title' | 'menu' | 'versus' | 'match' | 'fury' | 'victory' | 'defeat' | 'draw';
export type MusicCue = 'recruitment';
export type SoundEffect = 'menuConfirm' | 'goal' | 'finalWhistle';

export type MusicTrack = {
  id: string;
  title: string;
  src: string;
};

type MusicStage = {
  poolId: string;
  tracks: readonly MusicTrack[];
  repeat: boolean;
};

export type MusicPlan = {
  stages: readonly MusicStage[];
};

const track = (id: string, title: string, file: string): MusicTrack => ({
  id,
  title,
  src: `/music/${file}`,
});

const menuTracks = [
  track('lets-play-soccer', "Let's Play! Soccer", 'menu-lets-play-soccer.mp3'),
  track('unmotivated-members', 'Unmotivated Members', 'menu-unmotivated-members.mp3'),
  track('raimon-high-school', 'Raimon High School', 'menu-raimon-high-school.mp3'),
  track('friends', 'Friends', 'menu-friends.mp3'),
  track('chronicle-060', 'BGM Chronicle 060', 'menu-chronicle-060.mp3'),
  track('chronicle-119', 'BGM Chronicle 119', 'menu-chronicle-119.mp3'),
] as const;

const matchTracks = [
  track('soccer-battle', 'Soccer Battle', 'match-soccer-battle.mp3'),
  track('formal-game', 'Formal Game', 'match-formal-game.mp3'),
  track('chronicle-088', 'BGM Chronicle 088', 'match-chronicle-088.mp3'),
] as const;

export const furyTracks = [
  track('burning-phase', 'Activate! Burning Phase', 'fury-burning-phase.mp3'),
  track('chronicle-074', 'BGM Chronicle 074', 'fury-chronicle-074.mp3'),
  track('chronicle-100', 'BGM Chronicle 100', 'fury-chronicle-100.mp3'),
] as const;

const victoryStingers = [
  track('our-victory', 'Our Victory', 'win-our-victory.mp3'),
  track('soccer-battle-victory', 'Soccer Battle Victory', 'win-soccer-battle-victory.mp3'),
] as const;

const victoryThemes = [
  track('legendary-inazuma-eleven', 'The Legendary Inazuma Eleven', 'victory-legendary-inazuma-eleven.mp3'),
  track('begin', 'Begin', 'victory-begin.mp3'),
] as const;

export const musicPlans: Record<MusicScene, MusicPlan> = {
  title: { stages: [{ poolId: 'title', tracks: [track('chronicle-137', 'BGM Chronicle 137', 'title-chronicle-137.mp3')], repeat: true }] },
  menu: { stages: [{ poolId: 'menu', tracks: menuTracks, repeat: true }] },
  versus: { stages: [{ poolId: 'versus', tracks: [track('versus', 'VS', 'versus.mp3')], repeat: false }] },
  match: { stages: [{ poolId: 'match', tracks: matchTracks, repeat: true }] },
  fury: { stages: [{ poolId: 'fury', tracks: furyTracks, repeat: true }] },
  victory: { stages: [
    { poolId: 'victory-stinger', tracks: victoryStingers, repeat: false },
    { poolId: 'victory-theme', tracks: victoryThemes, repeat: false },
  ] },
  defeat: { stages: [{ poolId: 'defeat', tracks: [
    track('our-defeat', 'Our Defeat', 'loss-our-defeat.mp3'),
    track('soccer-battle-defeat', 'Soccer Battle Defeat', 'loss-soccer-battle-defeat.mp3'),
  ], repeat: false }] },
  draw: { stages: [{ poolId: 'draw', tracks: [track('match-result', 'Match Result', 'draw-match-result.mp3')], repeat: false }] },
};

export const musicCues: Record<MusicCue, MusicTrack> = {
  recruitment: track('raimon-soccer-club', 'Come! Raimon High Soccer Club', 'recruitment-raimon-club.mp3'),
};

export const soundEffects: Record<SoundEffect, MusicTrack> = {
  menuConfirm: track('menu-confirm', 'Confirmación de menú', 'sfx-menu-confirm.mp3'),
  goal: track('goal-whistle', 'Gol', 'sfx-goal-whistle.mp3'),
  finalWhistle: track('final-whistle', 'Silbato final', 'sfx-final-whistle.mp3'),
};

// Supplied for a future Imperial Academy-specific screen/event, as requested.
export const reservedTracks = {
  imperialAcademy: track('imperial-academy', 'Theme of the Imperial Academy', 'reserved-imperial-academy.mp3'),
} as const;
